import {
  BusinessInsightSchedule,
  ForecastListItem,
  PerformanceMetricsBusinessInsightsComparisonData
} from '@futrli-sdk/predict';

import { OrganisationOverviewView } from '@futrli/views/OrganisationOverviewView';

import { Option } from '../../types';

export { Recurrence, RecurrenceWeekDay, RecurrenceEndType, THE_LAST } from '../../../ui/recurrence-settings/types';

export interface EmailInsightsSidebarProps {
  view: OrganisationOverviewView;
  hasSchedules: boolean;
  selectedForecastId?: string;
  activeSchedule?: BusinessInsightSchedule;
  isOpen: boolean;
  handleClose: () => void;
  period: Option;
  periodData: PerformanceMetricsBusinessInsightsComparisonData;
  performanceToTargetsPeriodData?: PerformanceMetricsBusinessInsightsComparisonData;
  selectedForecast?: ForecastListItem;
  forecastsNotExist: boolean;
  customersSuppliersInfo: {
    unpaidCashInFromInvoices: string;
    unpaidCashOutFromBills: string;
    daysNumCustomersPaying: number;
    daysNumPayingToSuppliers: number;
  } | null;
}
